import React from 'react';
import { ReferenceListItem } from './model/ReferenceListItem';
import './ReferenceListSection.scss';

type Props = {
    references: ReferenceListItem[];
}

const ReferenceListSection: React.FC<Props> = (props: Props) => {
    return (
        <section className="reference-section container">
            <div className="container">
                <div>
                    參考資料:
                    <ol>
                        { props.references.map((x, index) => (
                            <li key={index}>
                                <div>
                                    {x.text}
                                    <a target="_blank" href={x.href} rel="noreferrer">{x.href}</a>
                                </div>
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        </section>
    );
}; 

export default ReferenceListSection;
